import React from 'react';

import { AuthLink } from '@components/Common';
import AuthLayout from '@components/Layout/AuthLayout';
import SignUpForm, { ISignUpFormData } from '@components/SignUpForm/SignUpForm';
import env from '@config/env';
import routes from '@config/routes';
import { useAuth } from '@hooks/useAuth';
import { useQueryParam } from '@hooks/useQueryParam';
import { useText } from '@hooks/useText';
import { Alert } from '@material-tailwind/react';

const SignUpPage = () => {
  const { t } = useText();
  const referralCode = useQueryParam('referralCode');
  const { signUp } = useAuth();

  const handleSubmit = async (data: ISignUpFormData) => {
    if (!data.password.password) {
      throw new Error('Password is required');
    }

    await signUp({
      email: data.email,
      password: data.password.password,
      referralCode: referralCode || undefined,
    });
  };

  if (env.REGISTRATION_DISABLED) {
    return (
      <AuthLayout title={t('authLayout.welcome')}>
        <Alert color="amber" className="text-center">
          Регистрация временно приостановлена в связи с техническими работами.
        </Alert>
        <div className="mt-3 flex justify-center">
          <AuthLink to={routes.LOGIN}>На главную</AuthLink>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t('authLayout.welcome')} message={t('signUp.title')}>
      <SignUpForm onSubmit={handleSubmit} />
    </AuthLayout>
  );
};

export default React.memo(SignUpPage);
